export const CLASS = {
  value: "CLASS",
  key: "memberCoverages.datatable.addTypes.class",
};
export const DIVISION = {
  value: "DIVISION",
  key: "memberCoverages.datatable.addTypes.division",
};
export const NEW = {
  value: "NEW",
  key: "memberCoverages.datatable.addTypes.new",
};
export const OTHER = {
  value: "OTHER",
  key: "memberCoverages.datatable.addTypes.other",
};
export const SALARY = {
  value: "SALARY",
  key: "memberCoverages.datatable.addTypes.salary",
};
export const STATUS = {
  value: "STATUS",
  key: "memberCoverages.datatable.addTypes.status",
};
export const TYPE = {
  value: "TYPE",
  key: "memberCoverages.datatable.addTypes.type",
};

export default [NEW, CLASS, DIVISION, SALARY, STATUS, TYPE, OTHER];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/coverage/enums/memberCoverageAddTypes.js